import {Component, OnInit} from '@angular/core';
import {ConfigurableDate} from './configurable-date.model';
import {ConfigurableDateService} from './configurable-date.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {SweetUtil} from '../components/commons/sweet/sweet-util-service';
import {DWPValidatorsService} from '../dwpvalidators.service';
import {AuthService} from '../auth/auth.service';
import {Market} from '../models/dealers/market.enum';

@Component({
  selector: 'app-configurable-date',
  templateUrl: './configurable-date.component.html',
  styleUrls: ['./configurable-date.component.css']
})
export class ConfigurableDateComponent implements OnInit {
  configurableDates: Array<ConfigurableDate>;
  submission: ConfigurableDate;
  saving: ConfigurableDate;
  form: UntypedFormGroup;
  showNLFields = false;


  constructor(private service: ConfigurableDateService, private formBuilder: UntypedFormBuilder, private sweetUtil: SweetUtil,
              private validatorService: DWPValidatorsService, private authService: AuthService) {
    this.form = formBuilder.group({
      submissionOrderDateMaxNumberOfDaysInTheFuture: [''],
      submissionOrderDateMaxNumberOfDaysInThePast: [''],
      submissionDeliveryDateMaxNumberOfDaysInThePast: [''],
      submissionDeliveryDateMaxNumberOfDaysInTheFuture: [''],
      submissionDeliveryDateMinNumberOfDaysInTheFuture: [''],

      savingDeliveryDateMaxNumberOfDaysInTheFuture: [''],
      savingDeliveryDateMinNumberOfDaysInTheFuture: [''],
      savingDeliveryDateMaxNumberOfDaysInThePast: [''],
      savingOrderDateMaxNumberOfDaysInThePast: [''],
      savingOrderDateMaxNumberOfDaysInTheFuture: ['']
    });

    this.showNLFields = authService.market() === Market.NL;
  }

  ngOnInit(): void {
    this.service.configurableDates().subscribe((dates: Array<ConfigurableDate>) => {

      this.configurableDates = dates;
      this.saving = this.configurableDateOfType('Saving');
      this.submission = this.configurableDateOfType('Submission');
      this.prepopulate();
    });
  }

  prepopulate(): void {
    this.form.setControl('submissionId', new UntypedFormControl(this.submission.id));
    this.form.setControl('submissionType', new UntypedFormControl(this.submission.type));

    this.form.setControl('submissionOrderDateMaxNumberOfDaysInTheFuture', new UntypedFormControl(this.submission.orderDateMaxNumberOfDaysInTheFuture, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('submissionOrderDateMaxNumberOfDaysInThePast', new UntypedFormControl(this.submission.orderDateMaxNumberOfDaysInThePast, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('submissionDeliveryDateMaxNumberOfDaysInThePast', new UntypedFormControl(this.submission.deliveryDateMaxNumberOfDaysInThePast, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('submissionDeliveryDateMaxNumberOfDaysInTheFuture', new UntypedFormControl(this.submission.deliveryDateMaxNumberOfDaysInTheFuture, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('submissionDeliveryDateMinNumberOfDaysInTheFuture', new UntypedFormControl(this.submission.deliveryDateMinNumberOfDaysInTheFuture, []));

    this.form.setControl('savingId', new UntypedFormControl(this.saving.id));
    this.form.setControl('savingType', new UntypedFormControl(this.saving.type));

    this.form.setControl('savingDeliveryDateMaxNumberOfDaysInTheFuture', new UntypedFormControl(this.saving.deliveryDateMaxNumberOfDaysInTheFuture, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('savingDeliveryDateMinNumberOfDaysInTheFuture', new UntypedFormControl(this.saving.deliveryDateMinNumberOfDaysInTheFuture, []));
    this.form.setControl('savingDeliveryDateMaxNumberOfDaysInThePast', new UntypedFormControl(this.saving.deliveryDateMaxNumberOfDaysInThePast, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('savingOrderDateMaxNumberOfDaysInTheFuture', new UntypedFormControl(this.saving.orderDateMaxNumberOfDaysInTheFuture, [this.validatorService.notBlank, this.validatorService.number]));
    this.form.setControl('savingOrderDateMaxNumberOfDaysInThePast', new UntypedFormControl(this.saving.orderDateMaxNumberOfDaysInThePast, [this.validatorService.notBlank, this.validatorService.number]));

  }

  save(): void {

    const save: ConfigurableDate = {
      id: this.valueFromForm('savingId'),
      type: this.valueFromForm('savingType'),
      deliveryDateMaxNumberOfDaysInThePast: this.valueFromForm('savingDeliveryDateMaxNumberOfDaysInThePast'),
      orderDateMaxNumberOfDaysInTheFuture: this.valueFromForm('savingOrderDateMaxNumberOfDaysInTheFuture'),
      orderDateMaxNumberOfDaysInThePast: this.valueFromForm('savingOrderDateMaxNumberOfDaysInThePast'),
      deliveryDateMaxNumberOfDaysInTheFuture: this.valueFromForm('savingDeliveryDateMaxNumberOfDaysInTheFuture'),
      deliveryDateMinNumberOfDaysInTheFuture: this.valueFromForm('savingDeliveryDateMinNumberOfDaysInTheFuture')
    };
    const submit: ConfigurableDate = {
      id: this.valueFromForm('submissionId'),
      type: this.valueFromForm('submissionType'),
      deliveryDateMaxNumberOfDaysInThePast: this.valueFromForm('submissionDeliveryDateMaxNumberOfDaysInThePast'),
      orderDateMaxNumberOfDaysInTheFuture: this.valueFromForm('submissionOrderDateMaxNumberOfDaysInTheFuture'),
      orderDateMaxNumberOfDaysInThePast: this.valueFromForm('submissionOrderDateMaxNumberOfDaysInThePast'),
      deliveryDateMaxNumberOfDaysInTheFuture: this.valueFromForm('submissionDeliveryDateMaxNumberOfDaysInTheFuture'),
      deliveryDateMinNumberOfDaysInTheFuture: this.valueFromForm('submissionDeliveryDateMinNumberOfDaysInTheFuture')
    };

    const dates: Array<ConfigurableDate> = [save, submit];
    this.service.save(dates).subscribe((resultingConfigurableDates) => {
      this.configurableDates = resultingConfigurableDates;

      this.saving = this.configurableDateOfType('Saving');
      this.submission = this.configurableDateOfType('Submission');
      SweetUtil.showSuccess('Successfully Saved The Dates');
    }, (error) => {
      this.sweetUtil.showError(`Failed To Save The Dates. Please make sure all the days entered are between 0 and 1460 days (4 years)`);
    });
  }

  private valueFromForm(fieldName: string): any {
    return this.form.get(fieldName).value;
  }

  private configurableDateOfType(type: string): ConfigurableDate {
    return this.configurableDates.find((date) => date.type === type);
  }

  formValid(): boolean {
    return this.form.valid;
  }
}
